import React from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  IconButton,
  Typography,
} from "@mui/material";
import { AddCircleOutline, ExpandMore } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

import { HelpBox } from "@/components/atoms";
import { MetaCategory, MetaInterest } from "@/types";
import { useInterestColor } from "@/utils";

interface MetaCategoryPanelProps {
  categories: MetaCategory[];
  selection: MetaInterest[][];
  activeSelection: number;
  editMode: boolean;
  onSelect: (interest: MetaInterest) => void;
  onMultiSelect: (interest: MetaInterest[]) => void;
  disabled?: boolean;
}

const MetaCategoryPanel: React.FC<MetaCategoryPanelProps> = ({
  categories,
  selection,
  activeSelection,
  editMode,
  onSelect,
  onMultiSelect,
  disabled = false,
}) => {
  const theme = useTheme();
  const { getColor } = useInterestColor(selection, activeSelection, editMode);

  return (
    <>
      {categories.map((category, idx) => (
        <Accordion key={`category-${idx}`}>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography>{category.meta_category}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box pb={4}>
              {category.interests.map((interest, interestIdx) => (
                <Chip
                  key={`${idx}-${interest.meta_id}`}
                  size="small"
                  color={getColor(interest.meta_id)}
                  label={interest.meta_name}
                  onClick={() => onSelect(interest)}
                  sx={{ m: 0.5 }}
                  disabled={disabled}
                />
              ))}
            </Box>
            <HelpBox title="Add all interests to my Audience Recipe">
              <IconButton
                sx={{
                  position: "absolute",
                  bottom: 8,
                  right: 12,
                  zIndex: 1,
                  p: 0.5,
                  borderRadius: "6px",
                  color: theme.palette.divider,
                }}
                onClick={() => onMultiSelect(category.interests)}
                disabled={disabled}
              >
                <AddCircleOutline fontSize="small" />
              </IconButton>
            </HelpBox>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};

export default MetaCategoryPanel;
